import { render, staticRenderFns } from "./UsersRole.vue?vue&type=template&id=540ee15e"
import script from "./UsersRole.vue?vue&type=script&lang=js"
export * from "./UsersRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports